import app from './app'
import file from './file'

export default { app, file }